import BRFLogo from 'assets/images/logos/Switchboard-logo.svg';
import production from './production';
import staging from './staging';
import development from './development';
import test from './test';

const configVariants = {
  production,
  staging,
  development,
  test,
};
const config = {
  freshworksId: 43000002432,
  partner: {
    url: 'https://app.switchboard.com', // UPDATE WHEN AVAILABLE
    name: 'Switchboard Load Board',
    partnerName: 'Switchboard',
    logo: BRFLogo, // UPDATE WHEN AVAILABLE
  },
  ...configVariants[process.env.NODE_ENV || 'development'],
};

export default config;
